import { useState, useEffect } from 'react';

export interface Props {
    value: string;
    delay: number;
}

function useDebounce({ value, delay }: Props) {
  // Stato per memorizzare il valore dopo il debounce
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(
    () => {
      // Imposta un timer per aggiornare il valore "debounced"
      // solo dopo che il tempo di "delay" è trascorso
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);

      // Funzione di pulizia: cancella il timer se il 'value'
      // o il 'delay' cambiano prima che il timer scada.
      // Questo è il cuore del debounce.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Esegui l'effetto solo se 'value' o 'delay' cambiano
  );

  return debouncedValue;
}

export default useDebounce;